import React    from 'react';
import BoxStore from '@widesk-ui/stores/BoxStore';

type BoxContextType = { boxStore?: BoxStore; }

const BoxContext = React.createContext<BoxContextType>({ boxStore: undefined });

export default BoxContext;
